import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  RequestTypes,
  businessUnitsKeys,
} from '@core/react-query/features/businessUnits'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { profileKeys } from '@core/react-query/features/profile/profileKeys'

export const useDeleteBusinessUnit = (
  options?: UseMutationOptions<
    string,
    RequestErrorType,
    RequestTypes['deleteBusinessUnit']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...businessUnitsKeys.deleteBusinessUnit,
    retry: 0,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: businessUnitsKeys._def })
      queryClient.invalidateQueries({
        queryKey: profileKeys.getUserStats._def,
      })
    },
  })
}
